export default "__VITE_ASSET__Dj4dtLat__"